/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PollResponse', 'model/PollReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PollResponse'), require('../model/PollReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PollReportApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PollResponse, root.ForStractionServiceApi.PollReport);
  }
}(this, function(ApiClient, PollResponse, PollReport) {
  'use strict';

  /**
   * PollReport service.
   * @module api/PollReportApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PollReportApi. 
   * @alias module:api/PollReportApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the pollReportAddResponsesPut operation.
     * @callback module:api/PollReportApi~pollReportAddResponsesPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addResponses
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PollResponse>} body 
     * @param {module:api/PollReportApi~pollReportAddResponsesPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.pollReportAddResponsesPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling pollReportAddResponsesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling pollReportAddResponsesPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PollReport/addResponses', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the pollReportCountUnrespondedPollsGet operation.
     * @callback module:api/PollReportApi~pollReportCountUnrespondedPollsGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * countUnrespondedPolls
     * @param {String} _4SAPIAppID 
     * @param {module:api/PollReportApi~pollReportCountUnrespondedPollsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.pollReportCountUnrespondedPollsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling pollReportCountUnrespondedPollsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PollReport/countUnrespondedPolls', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the pollReportLoadNewestPollsGet operation.
     * @callback module:api/PollReportApi~pollReportLoadNewestPollsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PollReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadNewestPolls
     * @param {String} _4SAPIAppID 
     * @param {Integer} limitTo 
     * @param {module:api/PollReportApi~pollReportLoadNewestPollsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PollReport>}
     */
    this.pollReportLoadNewestPollsGet = function(_4SAPIAppID, limitTo, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling pollReportLoadNewestPollsGet";
      }

      // verify the required parameter 'limitTo' is set
      if (limitTo == undefined || limitTo == null) {
        throw "Missing the required parameter 'limitTo' when calling pollReportLoadNewestPollsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'limitTo': limitTo
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PollReport];

      return this.apiClient.callApi(
        '/PollReport/loadNewestPolls', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the pollReportLoadUnrespondedPollsGet operation.
     * @callback module:api/PollReportApi~pollReportLoadUnrespondedPollsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PollReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadUnrespondedPolls
     * @param {String} _4SAPIAppID 
     * @param {module:api/PollReportApi~pollReportLoadUnrespondedPollsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PollReport>}
     */
    this.pollReportLoadUnrespondedPollsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling pollReportLoadUnrespondedPollsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PollReport];

      return this.apiClient.callApi(
        '/PollReport/loadUnrespondedPolls', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
